import { type SimpleOption } from '@retailer-platform/shared-components/src/common/select/utils/select.types'
import moment, { type Moment } from 'moment'
import {
  type InsightsPortalValueInput,
  type InsightsPortalFilterSelectionInput,
} from 'domains/insights-portal/api'

export const makeInsightsPortalValueInput = (value, valueType: keyof InsightsPortalValueInput) => ({
  [valueType]: value,
})

/* 
  transforms an array of selected filter options into an IN_FILTER filter selection 
  for insights portal queries
*/
export const transformOptionsToInsightsPortalInFilterSelection = (
  filterParam: SimpleOption[] | undefined,
  filterSelectionName: string,
  valueType: keyof InsightsPortalValueInput
): InsightsPortalFilterSelectionInput | undefined => {
  if (!filterParam || filterParam.length === 0) return

  return filterParam.reduce(
    (insightsPortalFilterSelection, selection) => {
      insightsPortalFilterSelection['inFilter'].values = [
        ...insightsPortalFilterSelection['inFilter'].values,
        makeInsightsPortalValueInput(selection.value, valueType),
      ]

      return insightsPortalFilterSelection
    },
    {
      name: filterSelectionName,
      inFilter: { values: [] },
    } as InsightsPortalFilterSelectionInput
  )
}

export const calculateComparisonPeriod = (
  from: Moment,
  to: Moment,
  comparisonType: 'lastPeriod' | 'lastYear' = 'lastYear'
): { from: Moment; to: Moment } => {
  if (comparisonType === 'lastPeriod') {
    const differenceInSeconds = to.diff(from, 'seconds')
    const lastPeriodTo = from.clone().subtract(1, 'seconds')
    const lastPeriodFrom = moment(lastPeriodTo).subtract(differenceInSeconds, 'seconds')

    return {
      from: lastPeriodFrom,
      to: lastPeriodTo,
    }
  }

  const lastPeriodTo = to.clone().subtract(1, 'year')
  const lastPeriodFrom = from.clone().subtract(1, 'year')

  return {
    from: lastPeriodFrom,
    to: lastPeriodTo,
  }
}
